"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isStyledComponent;

function isStyledComponent(target) {
  return typeof target === 'function' && typeof target.styledComponentId === 'string';
}


//////////////////
// WEBPACK FOOTER
// ./~/@vds/icons/~/@vds-core/utilities/dist/cjs/utils/isStyledComponent.js
// module id = 1445
// module chunks = 0